module.exports = __webpack_public_path__ + "static/media/wemby-banner-min.4305f40e.png";